import { UPDATE_SCREEN } from "actions/types";
export default (
  state = {
    mq: ""
  },
  action
) => {
  switch (action.type) {
    case UPDATE_SCREEN:
      state = {
        ...state,
        ...action.payload
      };
      return state;
    default:
      return state;
  }
};
